<template>
   <div class="schemeDocs">
       Scheme docs for {{widgetData.title}}
   </div>
</template>

<script>
export default {
    name: 'schemeDocsWidget',
    props: {
        widget: {
            type: Object,
            required: true,
        },
    },
    computed: {
        widgetData () {
            return this.$store.state.clientConfig.schemeDocs.find(items => items.id === this.widget.id);
        },
    },
    data () {
        return {

        };
    },
};
</script>

<style lang="scss" scoped>

</style>
